import { render, staticRenderFns } from "./UnauthorisedModal.vue?vue&type=template&id=5af43a9e"
import script from "./UnauthorisedModal.vue?vue&type=script&lang=js"
export * from "./UnauthorisedModal.vue?vue&type=script&lang=js"
import style0 from "./UnauthorisedModal.vue?vue&type=style&index=0&id=5af43a9e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af43a9e')) {
      api.createRecord('5af43a9e', component.options)
    } else {
      api.reload('5af43a9e', component.options)
    }
    module.hot.accept("./UnauthorisedModal.vue?vue&type=template&id=5af43a9e", function () {
      api.rerender('5af43a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Shared/UIComponents/UnauthorisedModal.vue"
export default component.exports